import { useCallback, type JSX } from 'react';
import { DocumentDuplicateIconOutline } from 'utils/icons';
import { copy } from 'utils/helpers';

type TaxFieldValueProps = {
  setBoundingBoxField: (field: string | null) => void;
  label: string;
  value: string | number | null | undefined;
  fieldName?: string | null;
  canCopy?: boolean;
};

const TaxFieldValue = ({
  setBoundingBoxField,
  label,
  value,
  fieldName,
  canCopy = true,
}: TaxFieldValueProps): JSX.Element | null => {
  const handleMouseEnter = useCallback(() => {
    setBoundingBoxField(fieldName as string);
  }, [setBoundingBoxField, fieldName]);

  const handleMouseLeave = useCallback(() => {
    setBoundingBoxField(null);
  }, [setBoundingBoxField]);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      copy(String(value));
    },
    [value],
  );

  if (value === null || value === undefined) return null;

  const displayValue = String(value);

  if (fieldName) {
    return (
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="cursor-default"
      >
        <p className="text-xs text-primary-400">{label}</p> {displayValue}
        {canCopy ? (
          <button className="ml-1" onClick={handleCopy}>
            <DocumentDuplicateIconOutline className="w-4 h-4 text-primary-400" />
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      <p className="text-xs text-primary-400">{label}</p>
      <p>{displayValue}</p>
      {canCopy ? (
        <button className="ml-1" onClick={handleCopy}>
          <DocumentDuplicateIconOutline className="w-4 h-4 text-primary-400" />
        </button>
      ) : null}
    </div>
  );
};

export default TaxFieldValue;
